var styleDataHash = '63910b02';  
export const injectCss = (() => {
  var css = `.ouD4p,.ouD4p:visited{color:var(--ricos-custom-mention-color,var(--ricos-action-color,#116dff));display:inline-block;text-decoration:none}[dir] .ouD4p,[dir] .ouD4p:visited{background:var(--ricos-custom-mention-background-color,transparent)!important;border-radius:2px}[dir=ltr] .ouD4p,[dir=ltr] .ouD4p:visited,[dir=rtl] .ouD4p,[dir=rtl] .ouD4p:visited{padding-left:2px;padding-right:2px}[dir=ltr] .zPQLA,[dir=ltr] .zPQLA:visited,[dir=rtl] .zPQLA,[dir=rtl] .zPQLA:visited{padding-left:4px;padding-right:4px}.ouD4p:focus,.ouD4p:hover{outline:0;text-decoration:underline}.ouD4p:active,.ouD4p:focus,.ouD4p:hover{color:var(--ricos-custom-mention-color,var(--ricos-action-color,#116dff))}[dir] .SJeqR{cursor:default}[dir] .uPNkw{cursor:pointer}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





